import { COMPANY, splitCompanyName } from "./helpers"

const CompanyHeader = ({
  name = COMPANY.name,
  phone = COMPANY.phone,
  email = COMPANY.email,
  address = COMPANY.address,
}) => {
  const { lead, last } = splitCompanyName(name)

  return (
    <>
      <span className="pdf-title pdf-uppercase">
        {lead && <>{lead} </>}
        <span className="pdf-brand-red">{last}</span>
      </span>
      <table className="pdf-table-py-2">
        <tbody>
          <tr>
            <td>{phone}</td>
          </tr>
          <tr>
            <td>{email}</td>
          </tr>
          <tr>
            <td>{address}</td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default CompanyHeader
